interface Product {
	title: string;
	quantity?: number;
}

function extractQuantity(title: string): { type: 'case' | 'bottles'; count: number } {
	const caseOrBottleRegex = /(\d+)x\d+cl/i; // Matches "XxYcl" with no spaces

	let match = caseOrBottleRegex.exec(title);

	if (match) {
		return { type: 'case', count: parseInt(match[1], 10) };
	}

	return { type: 'bottles', count: 1 }; // Default to 1 if no specific pattern matches
}

export function totalQuantities(products: Product[]): { value: number; type: 'bottles' | 'mixed-case' } {
	let cases = 0;
	let bottles = 0;
	let singleBottles = 0;
	let caseCount = 0;

	products.forEach((product) => {
		const result = extractQuantity(product.title);
		const quantity = product.quantity || 1;

		if (result.type === 'case' || product.title.toLowerCase().includes('case')) {
			cases += quantity;
			caseCount += 1;
			bottles += result.count * quantity;
		} else if (result.type === 'bottles') {
			singleBottles += result.count * quantity;
		}
	});

	if (caseCount === 1 && singleBottles === 0) {
		return { value: bottles, type: 'bottles' };
	} else if (caseCount > 1) {
		return { value: cases, type: 'mixed-case' };
	} else if (caseCount === 1 && singleBottles > 0) {
		return { value: bottles + singleBottles, type: 'bottles' };
	} else {
		return { value: singleBottles, type: 'bottles' };
	}
}
